import Phaser from 'phaser';

const SKY_TOP = 0x060914;
const SKY_BOTTOM = 0x1b2747;
const SILHOUETTE = 0x050712;
const SILHOUETTE_DEEP = 0x030509;
const WINDOW_COLOR = 0xfbbf24;
const WINDOW_DIM = 0xf59e0b;

export function drawNycSkyBackground(g: Phaser.GameObjects.Graphics, w: number, h: number) {
  g.clear();
  const band = 40;
  const step = Math.max(1, Math.floor(h / band));
  for (let y = 0; y < h; y += step) {
    const t = y / h;
    const r = lerp((SKY_TOP >> 16) & 0xff, (SKY_BOTTOM >> 16) & 0xff, t);
    const gC = lerp((SKY_TOP >> 8) & 0xff, (SKY_BOTTOM >> 8) & 0xff, t);
    const b = lerp(SKY_TOP & 0xff, SKY_BOTTOM & 0xff, t);
    g.fillStyle((r << 16) | (gC << 8) | b, 1);
    g.fillRect(0, y, w, step + 1);
  }
}

export function drawNycSilhouette(
  g: Phaser.GameObjects.Graphics,
  w: number,
  h: number,
  seed = 42,
) {
  const rand = mulberry32(seed);
  const baselineY = Math.floor(h * 0.72);
  const maxBuildingH = Math.floor(h * 0.38);

  g.fillStyle(SILHOUETTE_DEEP, 1);
  g.fillRect(0, baselineY + Math.floor(maxBuildingH * 0.5), w, h - baselineY);

  let x = -20;
  while (x < w + 20) {
    const bw = 20 + Math.floor(rand() * 60);
    const bh = Math.floor(maxBuildingH * (0.3 + rand() * 0.9));
    const bx = x;
    const by = baselineY + (maxBuildingH - bh);

    g.fillStyle(SILHOUETTE, 1);
    g.fillRect(bx, by, bw, h - by);

    if (rand() < 0.3) {
      const antennaH = 4 + Math.floor(rand() * 14);
      const antennaW = 2;
      g.fillRect(bx + Math.floor(bw / 2) - 1, by - antennaH, antennaW, antennaH);
    }

    const cols = Math.max(2, Math.floor(bw / 10));
    const rows = Math.max(3, Math.floor(bh / 14));
    for (let r = 0; r < rows; r++) {
      for (let c = 0; c < cols; c++) {
        if (rand() > 0.55) continue;
        const wx = bx + 3 + c * Math.floor(bw / cols);
        const wy = by + 4 + r * 12;
        if (wy > h - 4) continue;
        g.fillStyle(rand() < 0.3 ? WINDOW_DIM : WINDOW_COLOR, 1);
        g.fillRect(wx, wy, 3, 4);
      }
    }

    x += bw - Math.floor(rand() * 8);
  }
}

function lerp(a: number, b: number, t: number): number {
  return Math.round(a + (b - a) * t);
}

function mulberry32(seed: number) {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
